import {
    POST_CONVERSIONS_SUCCESS,
    POST_CONVERSIONS_FAIL,
    GET_CONVERSIONS_SUCCESS,
    GET_CONVERSIONS_FAIL,
    GET_GROUPS_SUCCESS,
    GET_GROUPS_FAIL,
    GET_USER_COMPANY_DATA_SUCCESS,
    GET_USER_COMPANY_DATA_FAIL
} from '../../../actions/carbonfootprint-rework/types/00-base-types';


const initialState = {
    loading: true,
    conversionData: [],
    groups: [],
    userCompanyData: []
};


export default function
    carbonFootprintBase(state = initialState, action) {

    const { type, payload } = action;

    switch (type) {
        case POST_CONVERSIONS_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case POST_CONVERSIONS_FAIL:
            return {
                ...state,
                loading: false
            }
        case GET_CONVERSIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                conversionData: payload
            };
        case GET_CONVERSIONS_FAIL:
            return {
                ...state,
                loading: false,
                conversionData: payload
            }
        case GET_GROUPS_SUCCESS:
            return {
                ...state,
                loading: false,
                groups: payload
            }
        case GET_GROUPS_FAIL:
            return {
                ...state,
                loading: false,
                groups: payload
            }
        case GET_USER_COMPANY_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                userCompanyData: payload
            }
        case GET_USER_COMPANY_DATA_FAIL:
            return {
                ...state,
                loading: false,
                userCompanyData: payload
            }
        default:
            return state;
    }
}


